import { Accordion, AccordionTab } from 'primereact/accordion'
import React, { useEffect, useState } from 'react'
import EditEstimating from '../ESTIMATING/EditEstimating'
import EDIT_PM_TEMPLATE from './EDIT_PM_TEMPLATE'
import EDIT_INTERIOR_DESIGN_TEMPLATE from '../INTERIOR DESIGN TEMPLATE/EDIT_INTERIOR_DESIGN'
import { useNavigate, useParams } from 'react-router-dom';
import { Api } from '../../../services/api'
import WARRANTY from '../WARRANTY/WARRANTY'
import JOB_AUTOPSY from '../JOB AUTOPSY/JOB_AUTOPSY'
import { Button } from 'primereact/button'
import { FaCopy, FaSync, FaCity, FaCalculator, FaHardHat, FaProjectDiagram, FaPaintRoller, FaLayerGroup, FaClipboardCheck, FaShieldAlt } from 'react-icons/fa'
import DEVELOPMENT_MANAGER_TEMPLATE from '../DEVELOPMENT MANAGER TEMPLATE/DEVELOPMENT_MANAGER_TEMPLATE'

import { TabView, TabPanel } from 'primereact/tabview';
import ConstructionAndInterior from '../CONSTRUCTION AND INTERIOR/ConstructionAndInterior'
import { IoArrowBackSharp } from 'react-icons/io5'
import EDIT_SP_TEMPLATE from './EDIT_SP_TEMPLATE'

import "../../Lidtracker/Leads/Leads.css";
import "../../Dasbord.css";

const EDIT_All_PLAYBOOKS = () => {
   const navigate = useNavigate();
   const { proId } = useParams();
   const { pmTeId } = useParams();
   const [projectName, setProjectName] = useState('');
   
   useEffect(() => {
      getProjectDetails();
   }, []);

   const getProjectDetails = () => {
      var _body = {
         projectId: proId,
      }
      const token = localStorage.getItem('authToken');
      const headers = {
         'Content-Type': 'application/json',
         'Authorization': token ? `Bearer ${token}` : ''
      };
      fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
         method: "POST",
         body: JSON.stringify(_body),
         headers: headers
      })
         .then((response) => response.json())
         .then((response) => {
            setProjectName(response.project_name);
         })
         .catch((error) => {
            console.error("Error:", error);
         });
   }


   const renderHeader = (title, icon) => (
      <span className="tab-header-title">
          {/* {icon} */}
          <span className="text-center">{title}</span>
      </span>
  );

   return (
      <div className="dashboard-container flex flex-column h-screen overflow-hidden">
         <div className="dashboard-header fixed-header flex align-items-center justify-content-between p-3 border-bottom-1 surface-border" style={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: 'white'
            }}>
            <Button 
                type='button' 
                onClick={() => { navigate(-1); window.close(); }} 
                className='p-button-text p-button-secondary font-bold'
                icon={<IoArrowBackSharp className='mr-2' size={20}/>}
            >
                Back
            </Button>
            
            <div className="text-center flex flex-column">
                {/* <span className="text-xl text-500">Project:</span> */}
                <span className="text-2xl font-bold text-900">{projectName || 'Loading...'}</span>
            </div>

            <Button 
                className="copySave-button p-2" 
                onClick={() => window.location.reload()} 
                type="button" 
                tooltip="Refresh Page"
                tooltipOptions={{ position: 'bottom' }}
            >
                <FaSync className="mr-2" />
                Refresh
            </Button>
         </div>

         <div className="flex-grow-1 overflow-y-auto p-2" style={{ backgroundColor: '#f8f9fa' }}>
            <TabView renderActiveOnly={false} className="custom-tabview">

               <TabPanel header={renderHeader(<>DEVELOPMENT<br />MANAGER</>, <FaCity />)} className="accordian-header m-1">
                  <DEVELOPMENT_MANAGER_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>PRECONSTRUCTION<br />MANAGER</>, <FaCalculator />)} className="accordian-header m-1">
                  <EditEstimating ProjectIdEdit={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>SUPERINTENDENT<br />CONSTRUCTION</>, <FaHardHat />)} title='Superintendent Construction' className="accordian-header m-1">
                  <EDIT_SP_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>CONSTRUCTION<br />MANAGER</>, <FaProjectDiagram />)} className="accordian-header m-1">
                  <EDIT_PM_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>INTERIOR<br />DESIGNER</>, <FaPaintRoller />)} className="accordian-header m-1">
                  <EDIT_INTERIOR_DESIGN_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>CONSTRUCTION MANAGER & INTERIOR<br /> DESIGNER</>, <FaLayerGroup />)} className="accordian-header m-1">
                  <ConstructionAndInterior pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>JOB<br />AUTOPSY</>, <FaClipboardCheck />)} className="accordian-header m-1">
                  <JOB_AUTOPSY pmId={proId} />
               </TabPanel>

               <TabPanel header={renderHeader(<>WARRANTY<br />TEMPLATE</>, <FaShieldAlt />)} className="accordian-header m-1">
                  <WARRANTY pmId={proId} />
               </TabPanel>

            </TabView>
         </div>

      </div>
   )
}

export default EDIT_All_PLAYBOOKS